




















import FinanceBar from '../../components/finance-bar.vue';
import FinanceContainer from '../../components/finance-container.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import api_simulaion from '@/Api/api_simulaion';
import { getQueryString } from '@/Api/api_data';
import Api from '@/Api/api_simulaion';
import { PlanList } from '@/prioritization/interface/interface';
import MessageBus from '@/Utils/message/message-bus';
import { delayedPromise } from '@/Utils/promise-utils';
import { DataLoad } from '@/Utils/decorator/data-load';
import Tools from '@/component/template/tools/tools';

/**
 *
 */
interface DataStructure {
    /**
     *
     */
    项目动态总投资: number;
    /**
     *
     */
    年销售收入: number;
    /**
     *
     */
    平均年总成本费用: number;
    /**
     *
     */
    总投资收益率: number;
    /**
     *
     */
    资本金利润率: number;
    /**
     *
     */
    资本金内部收益率: number;
    /**
     *
     */
    所得税前投资内部收益率: number;
    /**
     *
     */
    所得税前投资财务净现值: number;
    /**
     *
     */
    所得税前投资回报期: number;
    /**
     *
     */
    所得税后投资内部收益率: number;
    /**
     *
     */
    所得税后投资财务净现值: number;
    /**
     *
     */
    所得税后投资回报期: number;
}

const defaultFinancialAppraisalData = {
    项目动态总投资: 0,
    年销售收入: 0,
    平均年总成本费用: 0,
    总投资收益率: 0,
    资本金利润率: 0,
    资本金内部收益率: 0,
    所得税前投资内部收益率: 0,
    所得税前投资财务净现值: 0,
    所得税前投资回报期: 0,
    所得税后投资内部收益率: 0,
    所得税后投资财务净现值: 0,
    所得税后投资回报期: 0,
};

/**
 * 财务评价结果
 */
@Component({ components: { 'finance-bar': FinanceBar, 'finance-container': FinanceContainer } })
export default class Finance extends Vue {
    /** */
    flag = false;

    /** */
    relatedPlanList: PlanList[] = [];

    /** 关联项目simuId */
    relatedSimuId = -1;

    /** */
    financialAppraisalData: DataStructure = JSON.parse(JSON.stringify(defaultFinancialAppraisalData));

    /** */
    relatedData: DataStructure = JSON.parse(JSON.stringify(defaultFinancialAppraisalData));

    /** */
    signTime = 0;

    /**
     *获取相对计划列表
     */
    async getRelatedPlanList(): Promise<unknown> {
        const id = getQueryString()['simu_id'] as unknown as number;
        return Api.getRelatedOptimizationResult({ resultType: 0, simuid: id }).then((data) => {
            this.relatedPlanList = (<{ data: PlanList[]; simu: number }>data).data;
            this.relatedSimuId = (<{ data: PlanList[]; simu: number }>data).simu;
        });
    }

    /**
     *获取关联项目计算结果数据
     */
    async getRelatedCalculateData(planId?: number): Promise<void> {
        if (planId == null) {
            planId = 1;
        }
        if (this.relatedSimuId == null || this.relatedSimuId === -1) {
            return;
        }
        if (this.relatedSimuId !== -1) {
            const results = (await api_simulaion.getOverviewResult({ simu_id: this.relatedSimuId, planId: planId })).results;
            if (results[0] != null) {
                this.relatedData = results[results.length - 1].data;
            } else {
                this.relatedData = JSON.parse(JSON.stringify(defaultFinancialAppraisalData));
                MessageBus.Notification('warning', {
                    description: '当前对比方案没有数据,可能未进行过计算,请返回该方案进行计算!',
                    message: '提示',
                    key: '财务评价结果概览弹框',
                });
            }
        }
    }

    /**
     *
     */
    mounted(): void {
        // 取消router层的margin样式
        const el = this.$el as any; // eslint-disable-line
        el.style.margin = '0px 12px';

        this.getCalculateResult().catch((e) => {
            throw new Error(e);
        });
        this.getRelatedPlanList()
            .then(() => this.getRelatedCalculateData())
            .catch((e) => {
                throw new Error(e);
            });
    }

    /**
     *
     */
    async exportToFile(): Promise<void> {
        const excelData = new Array<string[]>();
        excelData.push(new Array<string>());
        excelData.push(new Array<string>());
        Object.keys(this.financialAppraisalData).forEach((key, index) => {
            excelData[0][index] = key;
            excelData[1][index] = this.financialAppraisalData[key];
        });
        await Tools.exportXlsxFile(String(this.$route.meta?.title), [{ data: excelData }]);
    }

    /**
     *开始计算
     */
    async startCalculate(): Promise<void> {
        try {
            this.$notification.success({
                message: '正在计算',
                key: this.$options.name,
                duration: 0,
                description: '',
                //$createElement返回一个vNode,需要在vue.config.js里开启runtimeCompiler才可以使用,应用将会增加10kb
                icon: this.$createElement({ template: '<a-icon type="loading" style="color: #108ee9" />' }),
            });
            await api_simulaion.saveDataToclickhouse({ simuid: this.$route.query.simu_id, planId: this.$store.getters.getCurrentPlanId });
            await this.periodicGetCalculateResult();
            this.$notification.success({ message: '计算完成', key: this.$options.name, duration: 1, description: '' });
        } catch (e) {
            await this.$message.error({ content: '计算失败,错误为:' + String(e), key: '财务评价', duration: 2.5 });
            throw e;
        }
    }

    /**
     *
     */
    async getOverviewResult(): Promise<boolean> {
        const results = (
            await api_simulaion.getOverviewResult({
                simu_id: this.$route.query.simu_id,
                planId: this.$store.getters.getCurrentPlanId ?? 0,
                time: this.signTime,
            })
        ).results;
        if (results[0] != null) {
            this.signTime = results[0].time;
            this.financialAppraisalData = results[0].data;
            return true;
        } else {
            this.financialAppraisalData = JSON.parse(JSON.stringify(defaultFinancialAppraisalData));
            return false;
        }
    }

    /**
     *循环获取结果
     */
    async periodicGetCalculateResult(): Promise<void> {
        const isGotData = await this.getOverviewResult();
        if (!isGotData) {
            await delayedPromise(3000);
            await this.periodicGetCalculateResult();
        }
    }

    /**
     *获取当前planId
     */
    get currentPlanId(): number {
        return this.$store.getters.getCurrentPlanId;
    }
    /**
     *单次获取结果
     */
    @Watch('currentPlanId')
    @DataLoad()
    async getCalculateResult(): Promise<void> {
        this.signTime = 0;
        await this.getOverviewResult();
    }
}
